package com.milta.feature.route.domain.entity

/** Result of `POST /route-batches` and `POST /route-batches/{id}/reoptimize` (MIL-39). */
data class RouteBatchResult(
    val batchId: String,
    val totalDeliveries: Int,
    val totalDrivers: Int,
    val optimized: Boolean,
    val drivers: List<RouteBatchDriverProposal>,
)

/**
 * One driver's resulting route within the batch. [distanceKm]/[durationMinutes] are null when
 * [RouteBatchResult.optimized] is false (round-robin split, RoutaR never called) — rendered as
 * "Non calculée", not an error state. Carries only what the backend contract returns (no stop
 * address preview — `RouteBatchDriverDto` has no such field); driver name/phone are enriched
 * client-side from the enterprise driver list already loaded before this batch was created.
 */
data class RouteBatchDriverProposal(
    val driverAccountId: String,
    val routeId: String,
    val deliveryCount: Int,
    val distanceKm: Double?,
    val durationMinutes: Int?,
)

/** Result of `POST /route-batches/{id}/dispatch` (MIL-39). */
data class RouteBatchDispatchResult(
    val batchId: String,
    val status: String,
    val dispatchedAt: String,
    val routeIds: List<String>,
)
